import { render, staticRenderFns } from "./setExample.vue?vue&type=template&id=edd1c6c4&scoped=true"
import script from "./setExample.vue?vue&type=script&lang=js"
export * from "./setExample.vue?vue&type=script&lang=js"
import style0 from "./setExample.vue?vue&type=style&index=0&id=edd1c6c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd1c6c4",
  null
  
)

export default component.exports